import gql from 'graphql-tag';

export const LISTING_SHARING_FRAGMENT = gql`
    fragment LISTING_SHARING_FRAGMENT on ListingData {
        listingId
        listingUris {
            detail
        }
        title
    }
`;
